module.exports = __webpack_public_path__ + "img/r.ec7f49a6.png";